/**
 * Check if the email is valid
 * @param email
 * @returns {boolean}
 */
export const checkValidEmail = (email) => {
  const emailRegexp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  return emailRegexp.test(email)
}
